import React from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

class RelatedProductsAutocomplete extends React.Component {
  handleChange = selectedOption => {
    this.props.setRelatedProducts(selectedOption);
  };

  render() {
    const {relatedProductsSelected} = this.props;
    return (
      <div style={{
        marginTop: 10,
        paddingVertical: 20
      }}>
        <Select
          value={relatedProductsSelected}
          components={animatedComponents}
          onChange={this.handleChange}
          options={this.props.products.map(product => {
            return {
              value: product.id,
              label: product.name,
            }
          })}
          isMulti
          isSearchable
          placeholder={"Add related products..."}
        />
      </div>
    );
  }
};

export default RelatedProductsAutocomplete;



// WEBPACK FOOTER //
// ./src/components/Products/relatedProductsAutocomplete.js